import styled from 'styled-components';
import ChargingSvg from '../../assets/amenities/charging.svg';

const ChargingIcon = styled(ChargingSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default ChargingIcon;
